

const dataRoadMap = [

    {
        id: 1,
        time: 'December 01, 2023',
        title: 'Idea Generation',
        desc: '모르는 사람과 어떻게 하면 쉽게 연결될 수 있을까?라는 질문을 시작으로 영빈과 상현이 아이디어를 처음 논의했습니다. 우리는 가방에 걸고 다닐 수 있는 키링을 통해 식별가능한 아바타를 활용한 연결 방법을 고안했습니다.',
        class: ''
    },
    {
        id: 2,
        time: 'January 01, 2024',
        title: 'Market Vrification',
        desc: '디지털 명함과 아트토이를 합친 저희 제품에 관한 시장의 수요를 검증하고 예측하기 위한 방법을 고민하였고, 오프라인에서 접근가능한 디지털 명함 \'TOY QR\' 프로젝트를 시작했습니다.',
        class: 'right'
    },

    {
        id: 3,
        time: 'March 01, 2024',
        title: 'Design & Development',
        desc: '아바타를 생성하여 온라인 정보와 Linking하는 제품의 최소기능을 정의하고 Web APP으로 TOY QR 제품의 형태를 결정하였습니다. 백엔드 개발과 이미지 생성 API 개발을 진행하였고, 민승 개발자 팀원을 추가 영입하였습니다.',
        class: ''
    },

    {
        id: 4,
        time: 'June 01, 2024',
        title: 'Release & Invest',
        desc: 'TOY QR를 출시하여 사용자 활동을 추적하고, QR 프로필 굿즈제작에 대한 크라우드 펀딩을 진행합니다. 2024 학생 창업유망팀 300+ 성장트랙에 참여하여 정부 및 개인으로부터 TOY KI 개발 자금을 유치합니다.',
        class: 'right'
    },
    {
        id: 5,
        time: 'September 01, 2024',
        title: 'Design & Development',
        desc: '3D 아바타 생성형 모델 개발과 프린팅 과정의 파이프라인을 구축합니다. TOY KI와 연동되어 유저간 소통하고 연결될 수 있는 어플리케이션 개발을 진행합니다.',
        class: ''
    },



]

export default dataRoadMap;